import React from "ES/lib/react";
import esUtils from "ES/utils/esUtils";
import ErrorAlert from "ES/widgets/ErrorAlert";
import ModalDialog from "../../widgets/ModalDialog";
import RadioServiceMixin from "ES/lib/react-pubsub-via-radio.js/RadioServiceMixin";

let ActionBtn = function (props) {
    let className = "btn btn-success";
    let {is_waiting, onClick} = props;

    if (is_waiting) {
        className += " disabled";
    }

    return <button className={className} onClick={onClick}>
        {props.children}
        {is_waiting
            ? <i className="fa fa-spinner fa-spin" style={{marginLeft: "1em"}}/>
            : null}
    </button>;
};

export default React.createClass({
    mixins: [RadioServiceMixin],
    RadioService_setup(){
        return {
            Marketplace_disconnectStripeAccount: {
                key(){
                    let {sid} = this.props;
                    return sid;
                },
                on: {
                    succeeded(){
                        let {onClose, reloadData} = this.props;
                        reloadData();
                        onClose();
                    }
                }
            }
        };
    },
    __doIt: esUtils.wrapPreventDefault(function () {
        let {sid} = this.props;
        this.RadioService_callService("Marketplace_disconnectStripeAccount", {
            speaker_id: sid
        });
    }),
    render: function () {
        let {onClose} = this.props;
        let ajax = this.state.Marketplace_disconnectStripeAccount;

        return <ModalDialog
            title="Disconnect Stripe Account"
            buttons={[]}
            onClose={ajax.waiting
                ? null
                : onClose}
        >
            <ErrorAlert message={ajax.error}/>
            <p>Your Stripe account is the way that client's payments end up in your bank account.</p>
            <p>If you disconnect from your Stripe account, you will:</p>
            <ul>
                <li>not be able to make an offer to a client</li>
                <li>not be able to accept a client's offer</li>
                <li>not be able to receive payments for jobs already accepted</li>
            </ul>
            <p style={{marginBottom: '2em'}}>...until you reconnect to a Stripe account.</p>

            <div className="modal-footer">
                <ActionBtn onClick={this.__doIt} is_waiting={ajax.waiting}>
                    Disconnect Stripe Account
                </ActionBtn>
                {!ajax.waiting && <button className="btn btn-default" onClick={onClose}>Never Mind</button>}
            </div>
        </ModalDialog>;
    }
});



// WEBPACK FOOTER //
// ./src/components/marketplace/MoneyTab/DisconnectStripeModal.js